<template>
  <nav class="tabset" :class="{ 'tabset-grayed': grayed }">
    <div class="container container-fluid">
      <div class="nav tabs-nav">
        <div class="inner container-fixed" role="tablist">
          <h3 v-if="hasSlotLabel">
            <slot name="label"></slot>
          </h3>
          <a
            v-for="t in headers"
            :key="t.name"
            :title="t.title ? $to(t.title) : $tt(t.label)"
            class="nav-link hidden-s hidden-xs"
            role="tab"
            :class="{ selected: t.isActive }"
            :aria-selected="String(t.isActive)"
            v-bind="options(t.isActive)"
            :aria-controls="'tab-' + t.name"
            href="#"
            @click.prevent="onSelect(t)"
            @keydown.space="onSelect(t)"
          >
            <span v-html="$to(t.label)"></span>
          </a>
          <div class="hidden-m hidden-l hidden-xl">
            <select v-model="dropdown" class="form-select offset-bottom-1" @change="onChange">
              <option v-for="(t, index) in headers" :key="index" :title="t.title" :value="index">
                <span v-html="$to(t.label)"></span>
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <slot v-if="slim" />
    <div v-else class="tab-content">
      <div class="outer container-fluid" :class="{ 'grayed-offset': grayed }">
        <div class="inner container-fixed">
          <slot></slot>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TabsetLayout',

  props: {
    headers: {
      type: Array,
      required: true,
    },

    selected: {
      type: Object,
      required: false,
      default: null,
    },

    grayed: {
      type: Boolean,
      required: false,
    },

    slim: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      dropdown: 0,
    };
  },

  computed: {
    hasSlotLabel() {
      return this.$scopedSlots.label;
    },
  },

  methods: {
    onChange() {
      this.$emit('select', this.headers[this.dropdown]);
    },

    onSelect(tab) {
      this.dropdown = this.headers.findIndex(el => el === tab);
      this.$emit('select', tab);
    },

    options(active) {
      if (active) {
        return {
          'aria-selected': 'true',
        };
      }
      return {};
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.tabset {
  .inner {
    padding-right: 0;
    padding-left: 0;
  }

  .tabs-nav {
    .inner {
      margin-top: 32px;
    }
  }

  .tab-content {
    .tabset-grayed & .outer {
      padding-bottom: 48px;
    }
    .outer .inner {
      padding-top: 12px;
      padding-right: 24px;
      margin-right: -24px;
    }
  }

  &.tabset-grayed {
    .tabs-nav {
      .inner {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .tab-content .inner {
      padding-right: 12px;
      padding-left: 12px;
      margin-right: auto;
    }
  }
}

@media screen and (max-width: #{$grid-medium-max}px) {
  .tabset-grayed .tabs-nav > .container-fixed {
    margin-right: 12px;
    margin-left: 12px;
  }
}

@media screen and (min-width: #{$grid-medium-min}px) {
  .tabs-nav {
    margin: 0 -12px;
    border-bottom: 2px solid #ededed;

    .label,
    h3 {
      position: relative;
      float: left;
      padding-right: 36px;
      padding-left: 12px;
      margin: 2px 0;
      font-weight: 400;
      color: $color-gray-darker;
    }

    a {
      position: relative;
      float: left;
      padding: 10px 12px;
      color: #757575;
      text-decoration: none;

      &::after {
        position: absolute;
        right: 12px;
        bottom: -2px;
        left: 12px;
        z-index: 1;
        height: 0;
        content: '';
        border: 0;
      }

      &.hover,
      &:hover {
        color: #383838;
        text-decoration: none;

        &::after {
          border-bottom: 4px solid #d0d0d0;
        }
      }

      &.selected::after {
        border-bottom: 4px solid #e20074;
      }

      &:active {
        border: none;
        outline: none;
      }
    }
  }
}
</style>
